import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=3640f88e"
import script from "../../../controllers/custom/class/class-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/class/class-edit.js?vue&type=script&lang=js&external"
import style0 from "./ClassEdit.vue?vue&type=style&index=0&id=3640f88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports